export default __webpack_public_path__ + "static/media/rule_element.ebe19b21.jpg";